var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCirclePlus = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M-5752-315a8.009,8.009,0,0,1,8-8,8.009,8.009,0,0,1,8,8,8.009,8.009,0,0,1-8,8A8.009,8.009,0,0,1-5752-315Zm1,0a7.008,7.008,0,0,0,7,7,7.008,7.008,0,0,0,7-7,7.008,7.008,0,0,0-7-7A7.008,7.008,0,0,0-5751-315Zm6.5,3.5v-3h-3a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h3v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3h3a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-3v3a.5.5,0,0,1-.5.5A.5.5,0,0,1-5744.5-311.5Z",
  transform: "translate(5752 323)"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCirclePlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circle-plus.86ed5834.svg";
export { ForwardRef as ReactComponent };